import React from 'react';
import Bem, { declMod } from '@yandex-lego/i-bem-react';

export default declMod({ border: 'transparent' }, {
    block: 'header2',
    content: function content() {
        return [this.__base.apply(this, arguments), React.createElement(Bem, { block: this.block, elem: 'white-stripe', key: 'white-stripe' })];
    }
});